import type { Props } from './../types/types';
import * as React from 'react';
import { View, IconButton, rem } from './../libs/WebComponents';


const IconButtonShadow = (props: Props) => {

   props = {
      color: 'var(--color-purple)',
      shadow: 'var(--color-green)',
      ...props,
   };

   const [gelatine, setGelatine] = React.useState('');
   React.useEffect(()=>{
      if (props.animate) {
         setTimeout(()=>setGelatine('gelatine'), props.animate);
      }else{
         setGelatine('');
      }
   },[props.animate]);

   return <View style={{display:'inline-block', ...props.containerStyle}}>
         <View className={gelatine}><IconButton {...props} containerStyle={null} /></View>
         <View style={{margin:'.7rem auto 0 auto',width:rem(2),height:rem(.5),backgroundColor:props.shadow, borderRadius:'100%'}}/>
      </View>
};

export default IconButtonShadow;